/**
 * Begin step route (CLA-1032) — eagerly registers the file route the self-serve
 * sign-up door lands on; the step component and its RPC/atom imports are
 * deferred to `begin.lazy.tsx` so they never reach the always-loaded `main`
 * chunk.
 *
 * @since 1.0.0
 */
import { createFileRoute } from "@tanstack/react-router";

export const Route = createFileRoute("/clawinstall/onboarding/begin")({});
